/** IconFont SVG 缓存 Service Worker 脚本路径（由 genSvgIconServiceWorker.js 生成至应用 public/） */
const ICON_CACHE_SW_URL = '/icon-cache-sw.js';

/** 避免重复注册 */
let registerPromise: Promise<ServiceWorkerRegistration | null> | null = null;

/**
 * 当前环境是否具备注册 IconFont SVG 缓存 Service Worker 的能力。
 * @returns {boolean}
 */
export function isSvgIconCacheServiceWorkerSupported(): boolean {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator;
}

/**
 * 是否为本地开发环境（与 IconFont 一致，开发走 /svg/ 静态资源，不启用 SW）。
 * @returns {boolean}
 */
function isLocalDevelopment(): boolean {
  return typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
}

/**
 * 注册 IconFont SVG 运行时缓存 Service Worker。
 * 不支持 SW 或开发环境下静默跳过；注册失败仅 warn，不影响 IconFont 正常 fetch。
 * @returns {Promise<ServiceWorkerRegistration | null>}
 */
export function registerSvgIconCacheServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!isSvgIconCacheServiceWorkerSupported() || isLocalDevelopment()) {
    return Promise.resolve(null);
  }

  if (registerPromise) {
    return registerPromise;
  }

  registerPromise = navigator.serviceWorker
    .register(ICON_CACHE_SW_URL, { scope: '/' })
    .then((registration) => registration)
    .catch((err) => {
      console.warn('[IconFont SW] register failed, fallback to direct fetch:', err);
      return null;
    });

  return registerPromise;
}
